import React, { Suspense } from 'react'
import { Loading } from 'components/shared'
import PageContainer from 'components/template/PageContainer'
import { Routes, Route, Navigate } from 'react-router-dom'
import AppRoute from 'components/route/AppRoute'

const PortalViews = ({ routes, defaultPath = '/dashboard' }) => {
    return (
        <Suspense fallback={<Loading loading={true} />}>
            <Routes>
                <Route path="/" element={<Navigate replace to={defaultPath} />} />
                {routes.map((route, index) => (
                    <Route
                        key={route.key + index}
                        path={route.path}
                        element={
                            <PageContainer pageContainerType="contained">
                                <AppRoute
                                    routeKey={route.key}
                                    component={route.component}
                                    {...route.meta}
                                />
                            </PageContainer>
                        }
                    />
                ))}
                <Route path="*" element={<Navigate to={defaultPath} replace />} />
            </Routes>
        </Suspense>
    )
}

export default PortalViews
